module.exports = __webpack_public_path__ + "img/executor.1e44c801.svg";